export const DEFAULT_CURRENCY = 'GBP'

export function getValidCurrencyCode(
  currency: string | null | undefined,
  fallback: string = DEFAULT_CURRENCY
): string {
  const code = (currency ?? '').trim().toUpperCase()

  if (!/^[A-Z]{3}$/.test(code)) {
    return fallback
  }

  try {
    new Intl.NumberFormat('en-GB', { style: 'currency', currency: code })
    return code
  } catch {
    return fallback
  }
}

export function formatCurrencySafe(
  amount: number,
  currency?: string | null,
  locale = 'en-GB',
  options?: Intl.NumberFormatOptions
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: getValidCurrencyCode(currency),
    ...options,
  }).format(amount)
}
